export default (theme) => ({
  shape__svg: {
    height: 212,
    width: 200,
  },
});
